<script lang="ts">
    import { _ } from "svelte-i18n"
    const properties = [
        {
            name: "free-shipping",
            icon: "thumbsup-black.svg",
            style: " height: 64px;",
        },
        {
            name: "quick-delivery",
            icon: "Clock-black.svg",
            style: " height: 64px;",
        },
        {
            name: "secure-payment",
            icon: "shield-check-black.svg",
            style: " height: 64px;",
        },
        {
            name: "uncomplicated-purchase",
            icon: "PaypalGroup-black.svg",
            style: "height: 32px",
        },
        {
            name: "purchase-on-account",
            icon: "bill-black.svg",
            style: "height: 64px;",
        },
    ]
</script>

<section class="page-wrapper">
    <ul class="properties">
        {#each properties as p}
            <li class="property">
                <p>{@html $_("properties." + p.name)}</p>
                <div class="image-wrapper">
                    <img style="{p.style}" src="{`/media/${p.icon}`}" alt="{p.name}" />
                </div>
            </li>
        {/each}
    </ul>
</section>

<style lang="less">
    @import "../../css/variables.less";
    .page-wrapper {
        background-color: white;
        justify-content: center;
        display: flex;

        .properties {
            display: flex;
            width: 100%;

            justify-content: center;
            flex-wrap: wrap;
            padding: 30px 20px;
            width: 90%;
            max-width: var(--containerwidth);
            gap: 60px;
            @media (min-width: @res-desktop) {
                gap: 50px;
            }
            .property {
                border-radius: 25px;
                border: 3px solid #f1f1f1;
                height: 140px;
                width: 200px;
                @media (min-width: @res-desktop) {
                    max-width: 186px;
                }
                flex-grow: 1;
                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: space-between;
                p {
                    width: calc(100% + 6px);
                    background-color: #f1f1f1;
                    height: 54px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    text-align: center;
                    white-space: wrap;
                    border-radius: 25px;
                    border: 3px solid #f1f1f1;
                    font-size: 0.9rem;
                    line-height: 22px;
                }
                .image-wrapper {
                    height: 64px;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    padding-bottom: 10px;
                    img {
                    }
                }
            }
        }
    }
</style>
